var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.804 6.715 9.23 18.271 3.2 12.26l.99-.99 5.04 5.058L19.814 5.725l.99.99Z",
    fill: "#000"
  })));
};
export { SvgTick as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yMC44MDQgNi43MTUxTDkuMjI5OTUgMTguMjcxMUwzLjE5OTk1IDEyLjI1OTFMNC4xODk5NSAxMS4yNjkxTDkuMjI5OTUgMTYuMzI3MUwxOS44MTQgNS43MjUxTDIwLjgwNCA2LjcxNTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";